<template>
    <form @submit.prevent="search()" novalidate>
        <div class="search-bar d-flex flex-column flex-sm-row">
            <t2g-select class="search-bar__select flex-fill"
                        :class="{'is-danger': industryError}"
                        v-model="industry"
                        :i18n-placeholder="i18nIndustryPlaceholder"
                        :items="industries"></t2g-select>
            <div class="search-bar__divider d-none d-sm-block"></div>
            <location-input class="search-bar__location flex-fill"
                            :class="{'is-danger': locationError}"
                            v-model="location"
                            :country="country"
                            :i18n-placeholder="i18nLocationPlaceholder"></location-input>
            <button class="search-bar__button cta cta--secondary align-self-end"
                    type="button"
                    @click="search()">{{i18nSearch}}
            </button>
        </div>
    </form>
</template>

<script>
  import T2gSelect from '@/components/T2gSelect';
  import LocationInput from '@/components/LocationInput';

  export default {
    name: 'SearchBar',
    components: {
      LocationInput,
      T2gSelect
    },
    props: [
      'i18nIndustryPlaceholder',
      'i18nLocationPlaceholder',
      'i18nSearch',
      'searchUrl',
      'country'
    ],
    data() {
      return {
        industry: null,
        location: null,
        industryError: false,
        locationError: false
      }
    },
    computed: {
      isMobile() {
        return this.$isMobile;
      },
      industries() {
        return T2G.industries;
      }
    },
    methods: {
      search() {
        const urlParams = [];
        let searchUrl = '';

        if (!this.industry) {
          this.industryError = true;
          return;
        } else {
          urlParams.push(this.industry);
        }

        if (!this.location) {
          this.locationError = true;
          return;
        } else {
          if (typeof this.location === 'string') {
            urlParams.push(this.location);
          } else if (this.location && this.location.address) {
            urlParams.push(this.location.address);
          }
        }

        // build search url
        searchUrl = `${this.searchUrl}/${urlParams.join('/')}`;

        if (this.location.lat && this.location.lng) {
          searchUrl += `?lat=${this.location.lat}&lng=${this.location.lng}`;
        }

        window.location = searchUrl;
      }
    }
  }
</script>


<style lang="scss" scoped>
    @import "../scss/variables";
    @import "../scss/mixins";
    @import "../scss/button";
    @import "../../node_modules/bootstrap/scss/functions";
    @import "../../node_modules/bootstrap/scss/variables";
    @import "../../node_modules/bootstrap/scss/mixins";

    .search-bar {
        @include media-breakpoint-up(sm) {
            height: 56px;
            border-radius: 28px;
            background: #fff;
            padding: 8px 8px 8px 32px;
        }

        &__select {
            @include media-breakpoint-only(xs) {
                height: 56px;
                padding: 8px 8px 8px 32px;
                margin-bottom: 16px;
                border-radius: 28px;
                background: #fff;
            }
        }

        &__location {
            @include media-breakpoint-only(xs) {
                align-items: center;
                padding: 8px 8px 8px 32px;
                margin-bottom: 16px;
                border-radius: 28px;
                background: #fff;
            }
        }

        &__divider {
            height: 40px;
            width: 0;
            border-right: 1px solid $light-grey-3;
        }

        &__button {
            width: 100%;
            padding: 16px;

            @include media-breakpoint-up(sm) {
                padding: 8px 16px;
                width: auto;
            }
        }
    }

    p {
        font-size: 1.2rem;
    }
</style>
